export const getTemperatureNameById = (temperature_id: number) => {
	switch (temperature_id) {
	case 1:
		return 'Ambient';
	case 2:
		return 'Chilled';
	case 3:
		return 'Frozen';
	default:
		return ''
	}
}